import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      
      {/* --- Header --- */}
      <div className="privacy-header-container">
        <h1 className="privacy-main-title">PRIVACY POLICY</h1>
        <p className="privacy-effective-date">Effective Date: December 31, 2025</p>
      </div>

      {/* --- Content --- */}
      <div className="privacy-content-container">
        <p className="privacy-intro">
          QuickFit (“QuickFit,” “we,” “our,” or “us”) operates the QuickFit mobile application and website (collectively, the “Service”). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.
        </p>
        <p className="privacy-intro">
          By using QuickFit, you agree to the collection and use of information in accordance with this policy.
        </p>

        <section className="privacy-section">
          <h2 className="privacy-section-title">1. Information We Collect</h2>
          
          <h3 className="privacy-subsection-title">a. Information You Provide</h3>
          <p>When you create an account or use the Service, we may collect:</p>
          <ul className="privacy-list">
            <li>Email address</li>
            <li>Account login credentials</li>
            <li>Order and delivery information</li>
            <li>Customer support communications</li>
          </ul>

          <h3 className="privacy-subsection-title">b. Automatically Collected Information</h3>
          <p>When you use the app, we may automatically collect:</p>
          <ul className="privacy-list">
            <li>Device information (device type, operating system)</li>
            <li>App usage data and diagnostics</li>
            <li>IP address and approximate location</li>
          </ul>

          <h3 className="privacy-subsection-title">c. Location Information</h3>
          <p>QuickFit may request access to location services to:</p>
          <ul className="privacy-list">
            <li>Show delivery availability</li>
            <li>Improve fulfillment accuracy</li>
          </ul>
          <p>Location access is optional and can be disabled in your device settings.</p>

          <h3 className="privacy-subsection-title">d. Payment Information</h3>
          <ul className="privacy-list">
            <li>Payments are processed by third-party payment processors.</li>
            <li>QuickFit does not store your full payment card details.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">2. How We Use Your Information</h2>
          <p>We use collected information to:</p>
          <ul className="privacy-list">
            <li>Create and manage user accounts</li>
            <li>Facilitate product discovery, ordering, and fulfillment</li>
            <li>Process transactions</li>
            <li>Improve app performance and user experience</li>
            <li>Communicate service updates and support responses</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">3. Third-Party Services</h2>
          <p>We may share limited information with trusted third parties solely to operate the Service, including:</p>
          <ul className="privacy-list">
            <li>Payment processors</li>
            <li>Analytics and performance monitoring providers</li>
            <li>Infrastructure and hosting providers</li>
          </ul>
          <p>These parties are authorized to use your information only as necessary to provide services to QuickFit.</p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">4. How We Share Information</h2>
          <ul className="privacy-list">
            <li>We do not sell your personal data.</li>
            <li>We may share information to fulfill orders and deliveries.</li>
            <li>With service providers acting on our behalf.</li>
            <li>To comply with legal requirements or protect rights and safety.</li>
            <li>In connection with a business transfer (e.g., merger or acquisition).</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">5. Data Retention</h2>
          <p>We retain personal information only as long as necessary to:</p>
          <ul className="privacy-list">
            <li>Provide the Service</li>
            <li>Meet legal and operational requirements</li>
          </ul>
          <p>You may request account deletion by contacting us.</p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">6. Your Choices and Rights</h2>
          <p>You may:</p>
          <ul className="privacy-list">
            <li>Update or correct your account information</li>
            <li>Disable location access in device settings</li>
            <li>Request deletion of your account and associated data</li>
          </ul>
          <p>To exercise these rights, contact us at the email below.</p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">7. Security</h2>
          <p>We take reasonable measures to protect your information. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">8. Children’s Privacy</h2>
          <p>QuickFit is not intended for users under the age of 13. We do not knowingly collect personal information from children.</p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">9. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.</p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-section-title">10. Contact Us</h2>
          <p>If you have questions about this Privacy Policy or our data practices, contact us at:</p>
          <p><strong>Email:</strong> support@quickfitapp.com</p>
          <p><strong>Website:</strong> <a href="https://www.quickfitapp.com">https://www.quickfitapp.com</a></p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;